/**
 * Checks whether `arg` is a promise or not.
 *
 * @returns {boolean}
 */
function isPromise(arg) {
  return Boolean(arg && arg.then);
}

export { isPromise };
